<script setup lang="ts">
import { cx } from '../ui'

defineProps<{
  class?: string
  mono?: boolean
  align?: 'left' | 'right' | 'center'
  colSpan?: number
}>()
</script>

<template>
  <td
    :colspan="colSpan"
    :class="
      cx(
        'px-4 py-2.5 align-middle text-left',
        mono && 'tnum',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        $props.class,
      )
    "
  >
    <slot />
  </td>
</template>
